import script from "./PageLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLoading.vue?vue&type=script&setup=true&lang=js"

import "./PageLoading.vue?vue&type=style&index=0&id=316e62f8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-316e62f8"]])

export default __exports__